import Page from 'modules/BiomeResults'

export default Page

